import React from 'react';
import ScrollReveal from '../common/ScrollReveal';
import bgFlores from '../../assets/images/home-about-bg-cortado.png';
import kanjiRojo from '../../assets/images/toyo-kanji-rojo.png';
import olas from '../../assets/images/home-about-olas.svg';

function AboutSection() {
  return (
    <section className="relative py-28 bg-brand-dark">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-cover opacity-70" 
           style={{ backgroundImage: `url(${bgFlores})` }}>
      </div>

      <div className="container relative mx-auto px-4">
        <ScrollReveal>
          <div className="max-w-4xl mx-auto mb-12 bg-brand-white rounded-3xl p-8 shadow-lg">
            {/* Título con kanji y olas */}
            <div className="relative mb-8">
              {/* Contenedor del título y kanji */}
              <div className="flex items-center gap-8">
                <img 
                  src={kanjiRojo} 
                  alt="" 
                  className="h-12 w-auto object-cover"
                />
                <h2 className="text-2xl md:text-2xl font-bold font-helvetica text-brand-dark tracking-wider">
                  QUIENES SOMOS
                </h2>
              </div>
              
              {/* Olas - solo visible en desktop */}
              <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2">
                <img 
                  src={olas} 
                  alt="" 
                  className="h-12 w-auto object-contain opacity-70"
                />
              </div>
            </div>

            {/* Contenido principal */}
            <div className="space-y-8">
              <ScrollReveal delay={0.2}>
                <p className="text-lg text-brand-dark leading-relaxed font-helvetica">
                  Toyo nació el 2 de enero de 2022 de la pasión por los esports y el sueño de crear algo significativo. 
                  Con sede en Paraguay y raíces japonesas, somos una organización que busca inspirar 
                  a través de la disciplina, la superación y el trabajo en equipo.
                </p>
              </ScrollReveal>
              
              <ScrollReveal delay={0.3}>
                <p className="text-lg text-brand-dark leading-relaxed font-helvetica">
                  En Toyo, competimos en títulos destacados y estamos comprometidos en preparar a las nuevas 
                  generaciones, desarrollando talento local e internacional mientras transitamos juntos el camino del 
                  guerrero.
                </p>
              </ScrollReveal>

              <ScrollReveal delay={0.4}>
                <h3 className="text-4xl font-morganite text-gray-200 tracking-wider text-left">
                  CRECE. LUCHA. EVOLUCIONA.
                </h3>
              </ScrollReveal>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}

export default AboutSection;